export default {"src":"/images/3.jpg","width":1000,"height":750,"aspectRatio":1.3333333333333333};